import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlotBookingComponent } from './slot-booking.component';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [SlotBookingComponent],
  imports: [CommonModule, TranslateModule, FlexLayoutModule],
  exports: [SlotBookingComponent],
})
export class SlotBookingModule {}
